module.exports = __webpack_public_path__ + "static/media/Gold-Mine.81b8a66d.jpeg";